import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayCashStockIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M17.5 10.25C15.77 10.25 13.97 10.53 12.75 11.13V5.5C12.75 3.61 9.51 2.75 6.5 2.75C3.49 2.75 0.25 3.61 0.25 5.5V20.5C0.25 22.39 3.49 23.25 6.5 23.25C8.63 23.25 10.87 22.82 12 21.9C13.13 22.82 15.37 23.25 17.5 23.25C20.51 23.25 23.75 22.39 23.75 20.5V13C23.75 11.11 20.51 10.25 17.5 10.25ZM6.5 4.25C9.49 4.25 11.21 5.14 11.25 5.5C11.21 5.86 9.49 6.75 6.5 6.75C3.51 6.75 1.79 5.86 1.75 5.5C1.79 5.14 3.51 4.25 6.5 4.25ZM11.25 20.5C11.21 20.86 9.5 21.75 6.5 21.75C3.5 21.75 1.79 20.86 1.75 20.5V18.46C2.93 19.06 4.72 19.37 6.5 19.37C8.28 19.37 10.07 19.05 11.25 18.45V20.5ZM11.25 16.97C10.83 17.43 9.23 18.12 6.5 18.12C3.77 18.12 2.17 17.43 1.75 16.97V14.71C2.93 15.31 4.72 15.62 6.5 15.62C8.28 15.62 10.07 15.3 11.25 14.7V16.97ZM11.25 13.22C10.83 13.68 9.23 14.38 6.5 14.38C3.77 14.38 2.17 13.69 1.75 13.23V10.97C2.93 11.57 4.72 11.88 6.5 11.88C8.28 11.88 10.07 11.57 11.25 10.97V13.23V13.22ZM11.25 9.47C10.83 9.93 9.23 10.62 6.5 10.62C3.77 10.62 2.17 9.93 1.75 9.47V7.37C2.97 7.97 4.77 8.25 6.5 8.25C8.23 8.25 10.03 7.97 11.25 7.37V9.47ZM17.5 11.75C20.49 11.75 22.21 12.64 22.25 13C22.21 13.36 20.5 14.25 17.5 14.25C14.5 14.25 12.79 13.36 12.75 13C12.79 12.64 14.51 11.75 17.5 11.75ZM22.25 20.5C22.21 20.86 20.5 21.75 17.5 21.75C14.5 21.75 12.79 20.86 12.75 20.5V18.45C13.93 19.06 15.71 19.37 17.5 19.37C19.29 19.37 21.07 19.06 22.25 18.46V20.5ZM22.25 16.97C21.83 17.43 20.23 18.12 17.5 18.12C14.77 18.12 13.17 17.43 12.75 16.97V14.85C13.97 15.45 15.77 15.74 17.5 15.74C19.23 15.74 21.03 15.46 22.25 14.86V16.96V16.97Z"
        fill={color}
      />
      <path
        d="M15.44 4.44001L16.87 3.01V8C16.87 8.35 17.15 8.62 17.49 8.62C17.83 8.62 18.11 8.34 18.11 8V3.01L19.54 4.44001C19.78 4.68001 20.18 4.68001 20.42 4.44001C20.66 4.20001 20.66 3.8 20.42 3.56L17.92 1.06C17.68 0.820005 17.28 0.820005 17.04 1.06L14.54 3.56C14.3 3.8 14.3 4.20001 14.54 4.44001C14.78 4.68001 15.18 4.68001 15.42 4.44001H15.44Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayCashStockIcon.displayName = 'PayCashStockIcon';
